(() => {
  'use strict';


  const NBE =
    window.NBE || {};

  window.NBE = NBE;


  /* =========================================================
     HELPERS
     ========================================================= */

  NBE.prefersReducedMotion = () => {

    return window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

  };


  /* =========================================================
     HERO INITIAL REVEAL
     ========================================================= */

  NBE.initHeroes = function (
    scope = document
  ) {

    const heroes =
      scope.querySelectorAll(
        '.nbe-hero'
      );


    heroes.forEach((hero) => {

      if (
        hero.dataset.nbeHeroReady === 'true'
      ) {
        return;
      }


      hero.dataset.nbeHeroReady =
        'true';


      requestAnimationFrame(() => {

        requestAnimationFrame(() => {

          hero.classList.add(
            'is-visible'
          );

        });

      });

    });

  };


  /* =========================================================
     TEXT REVEAL
     ========================================================= */

  NBE.initReveal = function (
    scope = document
  ) {

    const elements =
      scope.querySelectorAll(
        '.nbe-animate'
      );


    if (!elements.length) {
      return;
    }


    if (
      NBE.prefersReducedMotion() ||
      !(
        'IntersectionObserver'
        in window
      )
    ) {

      elements.forEach((element) => {

        element.classList.add(
          'is-visible'
        );

      });

      return;
    }


    if (!NBE.revealObserver) {

      NBE.revealObserver =
        new IntersectionObserver(
          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  !entry.isIntersecting
                ) {
                  return;
                }


                const element =
                  entry.target;


                let delay =
                  parseInt(
                    element.dataset
                      .nbeDelay || '0',
                    10
                  );


                if (
                  Number.isNaN(delay)
                ) {
                  delay = 0;
                }


                window.setTimeout(
                  () => {

                    element.classList.add(
                      'is-visible'
                    );

                  },
                  Math.max(
                    0,
                    Math.min(
                      delay,
                      1200
                    )
                  )
                );


                NBE.revealObserver
                  .unobserve(element);

              }
            );

          },
          {
            threshold: .14,
            rootMargin:
              '0px 0px -7% 0px'
          }
        );

    }


    elements.forEach((element) => {

      if (
        element.dataset
          .nbeRevealReady ===
        'true'
      ) {
        return;
      }


      element.dataset
        .nbeRevealReady =
        'true';


      NBE.revealObserver
        .observe(element);

    });

  };


  /* =========================================================
     PRODUCT CARD REVEAL
     ========================================================= */

  NBE.initProductCards = function (
    scope = document
  ) {

    const cards =
      scope.querySelectorAll(
        '.nbe-collection-grid ' +
        '#product-grid ' +
        '.card-wrapper'
      );


    if (!cards.length) {
      return;
    }


    if (
      NBE.prefersReducedMotion() ||
      !(
        'IntersectionObserver'
        in window
      )
    ) {

      cards.forEach((card) => {

        card.classList.add(
          'nbe-card-reveal',
          'is-visible'
        );

      });

      return;
    }


    if (!NBE.cardObserver) {

      NBE.cardObserver =
        new IntersectionObserver(
          (entries) => {

            entries.forEach(
              (entry) => {

                if (
                  !entry.isIntersecting
                ) {
                  return;
                }


                const card =
                  entry.target;


                card.classList.add(
                  'is-visible'
                );


                NBE.cardObserver
                  .unobserve(card);

              }
            );

          },
          {
            threshold: .08,
            rootMargin:
              '0px 0px -5% 0px'
          }
        );

    }


    cards.forEach(
      (card, index) => {

        if (
          card.dataset
            .nbeCardReady ===
          'true'
        ) {
          return;
        }


        card.dataset
          .nbeCardReady =
          'true';


        card.classList.add(
          'nbe-card-reveal'
        );


        /*
         * Lo stagger riparte ad ogni
         * gruppo di 5 card.
         *
         * Così le pagine molto grandi
         * non diventano lente.
         */

        const staggerIndex =
          index % 5;


        const delay =
          staggerIndex * 65;


        card.style.setProperty(
          '--nbe-card-delay',
          `${delay}ms`
        );


        NBE.cardObserver
          .observe(card);

      }
    );

  };


  /* =========================================================
     HERO PARALLAX
     ========================================================= */

  NBE.updateHeroMotion = function () {

    if (
      NBE.prefersReducedMotion()
    ) {
      return;
    }


    /*
     * Il parallax rimane solo desktop.
     * Sul telefono non serve.
     */

    if (
      window.innerWidth < 750
    ) {

      document
        .querySelectorAll(
          '.nbe-hero'
        )
        .forEach((hero) => {

          hero.style.removeProperty(
            '--nbe-media-shift'
          );

          hero.style.removeProperty(
            '--nbe-content-shift'
          );

          hero.style.removeProperty(
            '--nbe-content-opacity'
          );

          hero.style.removeProperty(
            '--nbe-scroll-opacity'
          );

        });


      return;

    }


    const heroes =
      document.querySelectorAll(
        '.nbe-hero'
      );


    heroes.forEach((hero) => {

      const rect =
        hero.getBoundingClientRect();


      /*
       * Non calcoliamo animazioni per
       * Hero molto lontane dal viewport.
       */

      if (
        rect.bottom < -100 ||
        rect.top >
          window.innerHeight + 100
      ) {
        return;
      }


      const height =
        Math.max(
          rect.height,
          1
        );


      const progress =
        Math.max(
          0,
          Math.min(
            1,
            -rect.top / height
          )
        );


      /*
       * Immagine leggermente più lenta
       * rispetto allo scroll.
       */

      const mediaShift =
        progress * 30;


      /*
       * Il testo sale appena.
       */

      const contentShift =
        progress * -18;


      /*
       * Il testo non sparisce:
       * perde solo leggermente presenza.
       */

      const contentOpacity =
        1 - (
          progress * .22
        );


      /*
       * L'indicatore SCORRI invece
       * scompare rapidamente.
       */

      const scrollOpacity =
        Math.max(
          0,
          1 - (
            progress * 4
          )
        );


      hero.style.setProperty(
        '--nbe-media-shift',
        `${mediaShift}px`
      );


      hero.style.setProperty(
        '--nbe-content-shift',
        `${contentShift}px`
      );


      hero.style.setProperty(
        '--nbe-content-opacity',
        contentOpacity.toFixed(3)
      );


      hero.style.setProperty(
        '--nbe-scroll-opacity',
        scrollOpacity.toFixed(3)
      );

    });

  };


  NBE.requestHeroMotion = function () {

    if (
      NBE.heroMotionTicking
    ) {
      return;
    }


    NBE.heroMotionTicking =
      true;


    requestAnimationFrame(() => {

      NBE.updateHeroMotion();

      NBE.heroMotionTicking =
        false;

    });

  };


  NBE.initHeroMotion =
    function () {

      if (
        NBE.heroMotionInitialized
      ) {
        return;
      }


      NBE.heroMotionInitialized =
        true;


      window.addEventListener(
        'scroll',
        NBE.requestHeroMotion,
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        NBE.requestHeroMotion,
        {
          passive: true
        }
      );


      NBE.requestHeroMotion();

    };


  /* =========================================================
     WATCH SHOPIFY PRODUCT GRID
     ========================================================= */

  NBE.observeProductGrids =
    function (
      scope = document
    ) {

      const grids =
        scope.querySelectorAll(
          '.nbe-collection-grid ' +
          '#ProductGridContainer'
        );


      grids.forEach((grid) => {

        if (
          grid.dataset
            .nbeGridObserved ===
          'true'
        ) {
          return;
        }


        grid.dataset
          .nbeGridObserved =
          'true';


        const observer =
          new MutationObserver(
            () => {

              window
                .requestAnimationFrame(
                  () => {

                    NBE.initProductCards(
                      grid
                    );

                  }
                );

            }
          );


        observer.observe(
          grid,
          {
            childList: true,
            subtree: true
          }
        );

      });

  };


  /* =========================================================
     GLOBAL INIT
     ========================================================= */

  NBE.init =
    function (
      scope = document
    ) {

      NBE.initHeroes(scope);

      NBE.initReveal(scope);

      NBE.initProductCards(scope);

      NBE.observeProductGrids(
        scope
      );

      NBE.initHeroMotion();

    };


  /* =========================================================
     DOCUMENT READY
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        NBE.init(document);

      },
      {
        once: true
      }
    );

  } else {

    NBE.init(document);

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      NBE.init(
        event.target ||
        document
      );

    }
  );


  document.addEventListener(
    'shopify:section:select',
    (event) => {

      const section =
        event.target;


      if (!section) {
        return;
      }


      section
        .querySelectorAll(
          '.nbe-animate'
        )
        .forEach((element) => {

          element.classList.add(
            'is-visible'
          );

        });


      section
        .querySelectorAll(
          '.nbe-card-reveal'
        )
        .forEach((card) => {

          card.classList.add(
            'is-visible'
          );

        });


      const hero =
        section.querySelector(
          '.nbe-hero'
        );


      if (hero) {

        hero.classList.add(
          'is-visible'
        );

      }


      NBE.requestHeroMotion();

    }
  );

})();